export default "__VITE_PUBLIC_ASSET__60e42763__"